export const environment = {
    production: false,
    tag: "QA",
    environmentBanner: "QA Environment",

    // sdkHostUrl: "https://cds-billers-qe-m-dmz.nfr02dmz.aciworldwide.com",
    // sdkVersion: "1.5.0",
    sdkHostUrl: "https://sandbox-cds.officialpayments.com",
    sdkVersion: "1.6.0",
    apiHistUrl: 'https://sandbox-api.acispeedpay.com',
    apiVersion: "v4",

    authServerBasePth: "https://portalserver-qa.acimobills.com/auth/api",

    auth: "Basic dXNyX2Rpc2J1cnNlbWVudHM6VTZaR3lEM2U2QVhobjhDZw==",

    disbursementsBasePath: '/disbursements/api',
    walletronBasePath: '/walletron/api',
    walletronRegions: [
        {region: "qa", baseUrl: "https://qa.walletron.com"}
    ]
};